export default __webpack_public_path__ + "static/media/man-right.75c84b1b.jpg";